import { Inject, Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { filter } from 'rxjs/operators';
// eslint-disable-next-line import-whitelist -- we need to get the keyboardShortcuts name type
import { keyboardShortcuts } from '../../core/shared/keyboard-shortcuts/keyboard-shortcuts';
import {
  ShellConnector,
  shellConnectorToken,
} from '../../team-apis/core/shell-connector';
import { EventTrackingValueWithSource } from '../misc-utils';

export type KeyboardShortcutName = keyof typeof keyboardShortcuts;

interface KeyboardShortcutEventInfo {
  shortcutName: string;
  keyboardEvent: KeyboardEvent;
  eventTrackingValue: EventTrackingValueWithSource;
}

@Injectable()
export class KeyboardShortcutService {
  keyboardShortcutEvent$ = new Subject<KeyboardShortcutEventInfo>();

  constructor(
    @Inject(shellConnectorToken) private shellConnector: ShellConnector,
  ) {}

  getMatchingEvent$(...shortcutNames: string[]) {
    return this.keyboardShortcutEvent$.pipe(
      filter(({ shortcutName: name }) => shortcutNames.includes(name)),
    );
  }

  getTooltipSuffix(shortcutName: string) {
    return ` (${this.shellConnector.getHumanReadableShortcut(shortcutName)})`;
  }
}
